import { useDep } from '~/compositions/dependency-container'
import CookiesService from '~/services/CookiesService'

export function useCookies() {
  return useDep(CookiesService)
}
